import jwt_decode from 'jwt-decode';
import store from '@/store';

export const Getters = {
  // implement getters here...
  checkSession(state) {
    if (state.accessToken) {
      const accessTokenDecoded = jwt_decode(state.accessToken);
      return {
        accessToken: state.accessToken,
        idToken: state.idToken,
        loggedIn: Date.now() < accessTokenDecoded.exp * 1000,
        username: state.username,
      };
    }
    const accessToken = localStorage.getItem('access_token');
    const idToken = localStorage.getItem('id_token');
    const username = localStorage.getItem('username');
    if (accessToken && idToken) {
      // check expiration
      try {
        const accessTokenDecoded = jwt_decode(accessToken);
        const expTimout = accessTokenDecoded.exp * 1000 - Date.now();
        if (expTimout > 0) {
          // special case - set renew token timer in case of refresh
          store.commit('session/setSessionData', {
            accessToken,
            idToken,
            loggedIn: Date.now() < accessTokenDecoded.exp * 1000,
            username,
          });
          return {
            accessToken,
            idToken,
            loggedIn: Date.now() < accessTokenDecoded.exp * 1000,
            username,
          };
        }
      } catch (err) {
        console.error(err);
      }
    }
    return { loggedIn: false };
  },
  getSessionExpireTime(state) {
    if (state.accessToken) {
      const accessTokenDecoded = jwt_decode(state.accessToken);
      return accessTokenDecoded.exp * 1000 - Date.now();
    }
    return null;
  },
  getAccessToken(state) {
    return state.accessToken;
  },
  loggedIn(state) {
    return state.loggedIn;
  },
  isSessionExpired(state) {
    if (!state.accessToken) return false;
    const accessTokenDecoded = jwt_decode(state.accessToken);
    return Date.now() > accessTokenDecoded.exp * 1000;
  },
};
